
import { Component, Mixins, Watch } from "vue-property-decorator";
import { Rectangle, Point } from "../../../../../../../base/domain/drawing";
import { AsyncRequestPool } from "../../../../../../../base/utilities";
import { MouseTrackableMixin } from "../../../../../../../base/components/system/mixins";
import { IFormatPageLocationRequest, IFormatPageLocationResult } from "../IFormatPageLocatable";

@Component
export default class QuestionnaireLocatableMixin extends Mixins(MouseTrackableMixin) {
  data(): any {
    return {
      locatorRequestPool: new AsyncRequestPool<Rectangle, { toRectangle: () => Rectangle, result: Rectangle }>(),
      locatingSource: { index: -1, isHitObject: false, isNextToObject: false },
    };
  }
  locatorRequestPool: AsyncRequestPool<Rectangle, { toRectangle: () => Rectangle, result: Rectangle }>;
  locatingSource: IFormatPageLocationRequest;

  get isLocating(): boolean {
    return this.locatorRequestPool.isProcessing
        && !this.locatorRequestPool.processingRequest.source.result;
  }

  get locatorRectangle(): Rectangle {
    return this.isLocatorVisible
      ? this.locatorRequestPool.processingRequest.source.toRectangle()
      : new Rectangle();
  }

  get isLocatorVisible(): boolean {
    return this.isLocating
        && this.isMouseTracking;
  }

  specifyIndexForLocator(index: number, isHitObject: boolean = false, isNextToObject: boolean = false): void {
    this.locatingSource = { index, isHitObject, isNextToObject };
  }

  @Watch("isMouseLeftButtonPressed")
  onMouseLeftButtonClickedForLocator(newValue: boolean) {
    if (newValue && this.isLocatorVisible && 0 <= this.locatingSource.index) {
      this.locatorRequestPool.processingRequest.source.result = this.locatorRequestPool.processingRequest.source.toRectangle();
    }
  }

  async locate(rectangle: Rectangle): Promise<IFormatPageLocationResult<Rectangle>> {
    this.locatingSource = { index: -1, isHitObject: false, isNextToObject: false };
    const located = await this._locate(
      () => new Rectangle(
        new Point(rectangle.x, this.mouseLocation.y),
        rectangle.size.clone())
    );
    const result = !located
      ? null
      : {
        result: new Rectangle(new Point(0, 0), located.size),
        index: this.locatingSource.index,
        isHitObject: this.locatingSource.isHitObject,
        isNextToObject: this.locatingSource.isNextToObject,
      };
    this.locatingSource = { index: -1, isHitObject: false, isNextToObject: false };
    return result;
  }

  private async _locate(getLocatorRectangle: () => Rectangle): Promise<Rectangle> {
    if (!getLocatorRectangle) {
      throw new Error("ロケータ矩形取得ハンドラが指定されていません.実装を確認してください.");
    }
    return this.locatorRequestPool.request(
      {
        toRectangle: getLocatorRectangle,
        result: null,
      },
      this,
      async (source: { toRectangle: () => Rectangle, result: Rectangle }) => {
        await this.$wait(() => !this.isLocating);
        return source.result;
      }
    );
  }

  cancelLocating(): void {
    this.locatorRequestPool.cancel(this);
  }
}
